/*
 * Public API Surface of pepperi-lib/rich-html-textarea
 */
export * from './rich-html-textarea.module';
export * from './rich-html-textarea.component';
